import { useState, useEffect } from "react";
import { Award } from "lucide-react";
import { ImageSlot } from "@/components/ImageSlot";
import { LeadDialog } from "@/components/public/LeadDialog";
import { Seo } from "@/components/Seo";
import { api, fileUrl } from "@/lib/api";

export default function About() {
  const [s, setS] = useState({});
  const [awards, setAwards] = useState([]);
  useEffect(() => {
    api.get("/settings").then((r) => setS(r.data || {})).catch(() => {});
    api.get("/awards?placement=about").then((r) => setAwards(r.data || [])).catch(() => {});
  }, []);
  return (
    <div data-testid="about-page">
      <Seo title="About MTM Marine Sales & Service | Bristol, TN" description="Learn about MTM Marine Sales & Service, a family-focused boat dealership in Bristol, TN serving the Tri-Cities and Southwest Virginia." />
      <section className="bg-mtm-charcoal text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <p className="text-xs font-bold uppercase tracking-widest text-mtm-teal-bright font-mono">Our Story</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold font-heading tracking-tight mt-3">About MTM Marine</h1>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 py-16 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        {s.about_image_path ? (
          <img src={fileUrl(s.about_image_path, 1100)} alt="MTM Marine Sales & Service team, 2026 Falcon Boats Dealer of the Year" className="rounded-lg w-full aspect-[4/3] object-cover shadow-sm" />
        ) : (
          <ImageSlot label="MTM-About-Mikey-Falcon-01.jpg" dimensions="1000 × 750" />
        )}
        <div>
          <h2 className="font-heading font-bold text-2xl sm:text-3xl text-slate-900">{s.about_headline}</h2>
          <p className="text-slate-600 mt-4 leading-relaxed">{s.about_body}</p>
          <h3 className="font-heading font-bold text-xl text-slate-900 mt-8">{s.about_story_headline}</h3>
          <p className="text-slate-600 mt-3 leading-relaxed">{s.about_story_body}</p>
          <div className="mt-6"><LeadDialog ctaType="General Inquiry" triggerLabel="Get in Touch" variant="purple" /></div>
        </div>
      </section>

      {awards.length > 0 && (
        <section className="bg-white border-y border-slate-200 py-14">
          <div className="max-w-7xl mx-auto px-4">
            <h2 className="font-heading font-bold text-2xl text-slate-900 mb-8 text-center">Awards & Recognition</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {awards.map((a) => (
                <div key={a.id} className="flex gap-4 bg-mtm-bg rounded-xl border border-slate-200 p-6">
                  <Award size={40} className="text-mtm-violet shrink-0" />
                  <div><h3 className="font-heading font-bold text-lg text-mtm-purple-deep">{a.title}</h3><p className="text-sm text-slate-600 mt-1">{a.description}</p></div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
